import mermaid from 'mermaid'
window.mermaid = mermaid;
